// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6ebbf010","259":"31d96553","369":"db77eeef","656":"ab843b9c","734":"4179b1a1","787":"4c6a7659","968":"13431d0e"}[chunkId] + ".chunk.js";
};